import styled, { keyframes } from 'styled-components';
import { color, device, fontSize } from 'theme';

const pulsate = keyframes`
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
`;

export const StyledButton = styled.button`
  height: 40px;
  min-width: 60px;
  padding: 8px 16px;
  background: transparent;
  color: ${color.white};
  border: none;
  outline: none;
  border-radius: 0;
  font-size: ${fontSize.small};
  cursor: pointer;
  transition: opacity 0.3s ease-in-out;
  pointer-events: all;
  opacity: ${(props) => (props.disabled ? 0.6 : 1)};
  display: inline-flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
  font-weight: normal;
  position: relative;
  z-index: 10;
  animation: ${(props) => (props.$pulsate ? pulsate : 'none')} 2.5s ease-in-out
    infinite;

  &:hover {
    opacity: 0.8;
  }

  &:focus {
    outline: none;
    border: none;
  }

  &:active {
    outline: none;
    border: none;
  }

  @media ${device.tablet} {
    font-size: ${fontSize.medium};
  }
`;

export const CloseRoundButton = styled.button`
  border-radius: 50%;
  width: 30px;
  height: 30px;
  border: 2px solid
    ${(props) => props.$borderColor || props.theme.mainColor || color.red};
  color: ${(props) => props.$color || props.theme.mainColor || color.red};
  background: transparent;
  position: relative;
  cursor: pointer;
  transition: all 0.3s ease-in-out;

  &:hover {
    border: 2px solid ${color.backgroundDark};
    background-color: ${(props) =>
      props.$hoverBg || props.theme.mainColor || color.red};

    &:before {
      color: ${color.backgroundDark};
    }
  }

  &::before {
    font-weight: bold;
    content: 'X';
  }
`;
